import { IClientAppSettings } from "./clientAppSettings"
const clientAppSettings: IClientAppSettings = {
    logServerRequests: false,
    logServerResponses: false,
    env: "Dev",
}

export default clientAppSettings
